var map = {
	"./app/components/BannerPapaPoints/i18n.js": 86483,
	"./app/components/BasePizzaSelector/i18n.js": 92580,
	"./app/components/Carousel/i18n.js": 19422,
	"./app/components/CartContent/components/CartVariant/i18n.js": 34820,
	"./app/components/CartContent/components/FreeProduct/i18n.js": 17390,
	"./app/components/CartContent/components/GiftCard/i18n.js": 3735,
	"./app/components/CartContent/components/ProductDetail/i18n.js": 85851,
	"./app/components/CartContent/components/PromoSelling/i18n.js": 5576,
	"./app/components/CartContent/components/UpsellingOption/i18n.js": 94951,
	"./app/components/CartContent/i18n.js": 60913,
	"./app/components/CartRedeemCoupon/i18n.js": 79120,
	"./app/components/CustomDatePicker/i18n.js": 43475,
	"./app/components/CustomModal/i18n.js": 14612,
	"./app/components/CustomPizza/i18n.js": 39869,
	"./app/components/CustomizableOption/components/CustomizableOptionList/i18n.js": 89370,
	"./app/components/DeliveryOrPickUp/components/Delivery/i18n.js": 86445,
	"./app/components/DeliveryOrPickUp/i18n.js": 12819,
	"./app/components/DispatchTypeDropdown/i18n.js": 89685,
	"./app/components/ErrorBoundary/i18n.js": 56548,
	"./app/components/ErrorMessage/i18n.js": 11239,
	"./app/components/FeaturedOffers/i18n.js": 27827,
	"./app/components/InputLabel/i18n.js": 18966,
	"./app/components/LastOrder/i18n.js": 24032,
	"./app/components/LoginPasswordless/ContactSupport/i18n.js": 57527,
	"./app/components/LoginPasswordless/steps/Email/i18n.js": 42598,
	"./app/components/LoginPasswordless/steps/Login/i18n.js": 66149,
	"./app/components/LoginPasswordless/steps/SignIn/i18n.js": 1464,
	"./app/components/LoginPasswordless/steps/Support/i18n.js": 32287,
	"./app/components/LoginPasswordless/steps/VerificationCode/i18n.js": 7048,
	"./app/components/MenuItem/components/NutritionalInfo/i18n.js": 801,
	"./app/components/MenuItem/components/Timer/i18n.js": 67589,
	"./app/components/MenuItem/i18n.js": 5600,
	"./app/components/MissingItemsMessage/i18n.js": 50421,
	"./app/components/ModifyProductModals/screens/ComboCreation/i18n.js": 69147,
	"./app/components/ModifyProductModals/screens/MakePizza/i18n.js": 8254,
	"./app/components/ModifyProductModals/screens/PizzaByHalves/screens/HalfSelection/i18n.js": 74716,
	"./app/components/Notification/i18n.js": 15389,
	"./app/components/PizzaCreation/components/Bases/i18n.js": 69647,
	"./app/components/PizzaCreation/components/Ingredients/i18n.js": 14245,
	"./app/components/PizzaCreation/i18n.js": 32537,
	"./app/components/Routes/components/SmartBanner/i18n.js": 82597,
	"./app/components/Routes/i18n.js": 85626,
	"./app/components/StartOrderButton/i18n.js": 42620,
	"./app/components/StoreSearchBar/i18n.js": 32398,
	"./app/components/Wizard/components/Footer/i18n.js": 66078,
	"./app/components/Wizard/i18n.js": 15425,
	"./app/screens/Authorization/screens/Login/i18n.js": 66790,
	"./app/screens/Authorization/screens/OldUser/i18n.js": 56599,
	"./app/screens/Authorization/screens/PhoneForm/i18n.js": 11115,
	"./app/screens/Authorization/screens/RecoverPassword/i18n.js": 466,
	"./app/screens/Authorization/screens/RecoverPassword/screens/RecoveryDone/i18n.js": 31130,
	"./app/screens/Authorization/screens/Register/i18n.js": 60564,
	"./app/screens/Authorization/screens/Register/screens/CodeVerification/i18n.js": 6459,
	"./app/screens/CallCenter/components/ClientHeader/components/CancelOrderModal/i18n.js": 14551,
	"./app/screens/CallCenter/components/ClientHeader/i18n.js": 73592,
	"./app/screens/CallCenter/screens/Checkout/components/ConfirmedOrderModal/i18n.js": 96101,
	"./app/screens/CallCenter/screens/Checkout/components/GoToMenuButton/i18n.js": 53535,
	"./app/screens/CallCenter/screens/Checkout/i18n.js": 99121,
	"./app/screens/CallCenter/screens/Login/i18n.js": 93608,
	"./app/screens/CallCenter/screens/NewOrder/components/ChangeInfoForm/i18n.js": 51567,
	"./app/screens/CallCenter/screens/NewOrder/components/ModalNewGuest/i18n.js": 82126,
	"./app/screens/CallCenter/screens/NewOrder/components/OrderSetup/i18n.js": 32926,
	"./app/screens/CallCenter/screens/NewOrder/i18n.js": 45179,
	"./app/screens/Dashboard/components/ChangeAddress/i18n.js": 35173,
	"./app/screens/Dashboard/components/ElectronicReceipt/i18n.js": 94127,
	"./app/screens/Dashboard/components/Footer/components/FooterTop/i18n.js": 49218,
	"./app/screens/Dashboard/components/Footer/i18n.js": 40526,
	"./app/screens/Dashboard/components/LastPaymentUsed/i18n.js": 15228,
	"./app/screens/Dashboard/components/Modals/components/AgeVerification/i18n.js": 65769,
	"./app/screens/Dashboard/components/Modals/components/CartHome/i18n.js": 47480,
	"./app/screens/Dashboard/components/Modals/components/DisabledItemsModal/i18n.js": 95520,
	"./app/screens/Dashboard/components/Modals/components/ExistingUserModal/i18n.js": 16772,
	"./app/screens/Dashboard/components/Modals/components/OfferCompletionModal/i18n.js": 26428,
	"./app/screens/Dashboard/components/Modals/components/OptimizedCartModal/i18n.js": 63963,
	"./app/screens/Dashboard/components/Modals/components/OrderRuleModal/i18n.js": 83702,
	"./app/screens/Dashboard/components/Modals/components/PaymentBrick/i18n.js": 64242,
	"./app/screens/Dashboard/components/Modals/components/PizzasTutorialModal/components/TutorialCarousel/i18n.js": 89613,
	"./app/screens/Dashboard/components/Modals/components/QuickOrder/i18n.js": 57912,
	"./app/screens/Dashboard/components/Modals/components/UpSelling/i18n.js": 26964,
	"./app/screens/Dashboard/components/Navbar/components/NavLinks/i18n.js": 50997,
	"./app/screens/Dashboard/components/Navbar/i18n.js": 13561,
	"./app/screens/Dashboard/components/PopUpRetargeting/i18n.js": 8589,
	"./app/screens/Dashboard/components/SelectTimeDispatch/i18n.js": 48410,
	"./app/screens/Dashboard/components/Snackbar/i18n.js": 13438,
	"./app/screens/Dashboard/screens/ContactForm/i18n.js": 16296,
	"./app/screens/Dashboard/screens/GiftCard/components/CustomOptionLabel/i18n.js": 19432,
	"./app/screens/Dashboard/screens/GiftCard/components/GiftCardBanner/i18n.js": 60966,
	"./app/screens/Dashboard/screens/GiftCard/i18n.js": 61274,
	"./app/screens/Dashboard/screens/HelpCenter/components/Header/components/Search/i18n.js": 58559,
	"./app/screens/Dashboard/screens/HelpCenter/i18n.js": 10052,
	"./app/screens/Dashboard/screens/Home/components/CarouselTemplate/i18n.js": 98725,
	"./app/screens/Dashboard/screens/Home/components/Cart/i18n.js": 70731,
	"./app/screens/Dashboard/screens/Home/components/Menu/components/FooterWithPrice/i18n.js": 31074,
	"./app/screens/Dashboard/screens/Home/components/Menu/components/OptionsProductModal/components/IngredientReplacement/i18n.js": 70417,
	"./app/screens/Dashboard/screens/Home/components/Menu/components/OptionsProductModal/i18n.js": 76692,
	"./app/screens/Dashboard/screens/Home/components/Menu/components/PizzaByHalvesModal/components/PizzaByHalves/i18n.js": 2529,
	"./app/screens/Dashboard/screens/Home/components/Menu/i18n.js": 88604,
	"./app/screens/Dashboard/screens/Home/components/OrderBuilder/components/Monitor/i18n.js": 92160,
	"./app/screens/Dashboard/screens/Home/components/PapaPointsBanner/i18n.js": 56806,
	"./app/screens/Dashboard/screens/Home/components/PromotionModal/i18n.js": 10199,
	"./app/screens/Dashboard/screens/Home/i18n.js": 19975,
	"./app/screens/Dashboard/screens/Home/redux/i18n.js": 59392,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/BlockedProductsModal/i18n.js": 73913,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/CrossSelling/i18n.js": 30630,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/DigitalDispatch/i18n.js": 92372,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/DispatchDetails/i18n.js": 37418,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/Modals/SinpeMovilModal/i18n.js": 41674,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/Modals/TimeUpModal/i18n.js": 73594,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/OrderDetail/components/CardCodeForm/i18n.js": 48340,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/OrderDetail/i18n.js": 74117,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/OrderReceiptModal/component/WarningOrderReceipt/i18n.js": 68268,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/components/CardPaymentList/components/EditCards/i18n.js": 40821,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/components/NIF/i18n.js": 25345,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/components/PaymentMethodList/i18n.js": 69815,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/i18n.js": 21608,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PersonalData/i18n.js": 11274,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/PersonalDataForm/i18n.js": 81264,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/RedeemCoupon/components/GiftCardBalance/i18n.js": 49802,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/RedeemCoupon/i18n.js": 4712,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/SauceSection/i18n.js": 59304,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/SuggestiveSells/i18n.js": 29545,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/components/TipSelection/i18n.js": 3985,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/i18n.js": 74744,
	"./app/screens/Dashboard/screens/Home/screens/Checkout/screens/OrderConfirmation/i18n.js": 60240,
	"./app/screens/Dashboard/screens/Landing/components/Search/i18n.js": 23801,
	"./app/screens/Dashboard/screens/Landing/i18n.js": 59275,
	"./app/screens/Dashboard/screens/Loyalty/components/Benefits/i18n.js": 92562,
	"./app/screens/Dashboard/screens/Loyalty/components/HowItWorks/i18n.js": 1127,
	"./app/screens/Dashboard/screens/Loyalty/components/JoinPapaPointsModal/i18n.js": 37998,
	"./app/screens/Dashboard/screens/Loyalty/i18n.js": 86924,
	"./app/screens/Dashboard/screens/NPS/i18n.js": 3239,
	"./app/screens/Dashboard/screens/NotFound/i18n.js": 63451,
	"./app/screens/Dashboard/screens/Order/i18n.js": 45342,
	"./app/screens/Dashboard/screens/Order/screens/ActiveOrders/components/GiftCardsDetails/i18n.js": 58675,
	"./app/screens/Dashboard/screens/Order/screens/ActiveOrders/components/Order/components/StoreDetail/i18n.js": 80518,
	"./app/screens/Dashboard/screens/Order/screens/ActiveOrders/components/OrdersTabs/i18n.js": 18783,
	"./app/screens/Dashboard/screens/Order/screens/ActiveOrders/i18n.js": 5618,
	"./app/screens/Dashboard/screens/Order/screens/PastOrders/components/OrderEntry/components/GiftCardItem/i18n.js": 53697,
	"./app/screens/Dashboard/screens/Order/screens/PastOrders/i18n.js": 26860,
	"./app/screens/Dashboard/screens/OtherPages/AboutUs/i18n.js": 62506,
	"./app/screens/Dashboard/screens/OtherPages/AboutUs/screens/OurCommitment/i18n.js": 38436,
	"./app/screens/Dashboard/screens/OtherPages/AboutUs/screens/OurValues/i18n.js": 81205,
	"./app/screens/Dashboard/screens/OtherPages/CookiesPolicy/i18n.js": 74834,
	"./app/screens/Dashboard/screens/OtherPages/Franchises/screens/ContactForm/i18n.js": 78122,
	"./app/screens/Dashboard/screens/OtherPages/Franchises/screens/Information/i18n.js": 6386,
	"./app/screens/Dashboard/screens/OtherPages/FreeChickens/i18n.js": 33521,
	"./app/screens/Dashboard/screens/OtherPages/Ingredients/i18n.js": 17293,
	"./app/screens/Dashboard/screens/OtherPages/OfficialStatement/i18n.js": 37719,
	"./app/screens/Dashboard/screens/OtherPages/Terms/i18n.js": 60548,
	"./app/screens/Dashboard/screens/OtherPages/WorkWithUs/i18n.js": 29512,
	"./app/screens/Dashboard/screens/PapaPoints/i18n.js": 25367,
	"./app/screens/Dashboard/screens/Profile/components/ProfileCard/i18n.js": 61532,
	"./app/screens/Dashboard/screens/Profile/i18n.js": 34389,
	"./app/screens/Dashboard/screens/Promos/i18n.js": 72450,
	"./app/screens/Dashboard/screens/Purchase/PurchaseControl/i18n.js": 28350,
	"./app/screens/Dashboard/screens/Purchase/PurchaseFail/i18n.js": 3779,
	"./app/screens/Dashboard/screens/Purchase/PurchaseOK/i18n.js": 89,
	"./app/screens/Dashboard/screens/Stores/components/StoreLanding/i18n.js": 20622,
	"./app/screens/Dashboard/screens/Stores/components/StoreList/components/Store/i18n.js": 54806,
	"./app/screens/Dashboard/screens/Stores/components/StoreList/i18n.js": 20605,
	"./app/screens/Dashboard/screens/Stores/i18n.js": 99652,
	"./app/screens/Dashboard/screens/Unavailable/i18n.js": 82808,
	"./app/screens/i18n.js": 47616,
	"./config/i18n.js": 52074,
	"./constants/i18n.js": 39368,
	"./redux/CustomPizza/i18n.js": 69097,
	"./utils/i18n.js": 74964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36506;